<div (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" (click)="onClick()" class="tdo-header-button" data-cy="header-button-container">
  <div [ngClass]="{'hovered': isHovered, 'selected': isSelected}" style="width: 40px; height: 40px; border-radius: 10px; position: absolute;" data-cy="header-button-background"></div>
  <div style="width: 40px; height: 40px; border-radius: 10px;" data-cy="header-button-content">
    @if (isShowBadge && badgeCount > 0) {
      <div [matBadge]="badgeCount" matBadgeColor="warn" matBadgeSize="small" style="margin-left: auto; margin-right: auto; width: fit-content; height: fit-content; transform: translateY(-55%); position: relative; top: 50%;" data-cy="header-button-badge-container">
        <img style="position: relative; width: 26px; height: 26px;" [style.left]="xOffset + 'px'" src="{{imagePath}}" data-cy="header-button-badge-image">
      </div>
    }

    @if (!isShowBadge || badgeCount == 0) {
      <div style="margin-left: auto; margin-right: auto; width: fit-content; height: fit-content; transform: translateY(-55%); position: relative; top: 50%;" data-cy="header-button-image-container">
        <img style="position: relative; width: 26px; height: 26px;" [style.left]="xOffset + 'px'" src="{{imagePath}}" data-cy="header-button-image">
      </div>
    }
  </div>
</div>
